import dayjs from 'dayjs';

export const getTimeString = (timeStamp: dayjs.Dayjs): string => {
  const date = timeStamp.date().toString();

  let cardinal;
  switch (date) {
    case '1':
      cardinal = 'st';
      break;
    case '2':
      cardinal = 'nd';
      break;
    case '3':
      cardinal = 'rd';
      break;
    default:
      cardinal = 'th';
      break;
  }

  const month = timeStamp.format('MMM').toString();
  const hour = timeStamp.hour().toString();

  let minute;

  if (timeStamp.minute() < 10) {
    minute = '0' + timeStamp.minute().toString();
  } else {
    minute = timeStamp.minute().toString();
  }

  return `${date}${cardinal} ${month}, ${hour}:${minute}`;
};
